import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { z } from "zod";

import { SchemaEnvironment } from "schema/environment";

export type EnvironmentState = z.infer<typeof SchemaEnvironment>;

const slice = createSlice({
  name: "environmentState",
  initialState: {} as EnvironmentState,
  reducers: {
    setEnvironment: (state, action: PayloadAction<EnvironmentState>) => {
      Object.assign(state, action.payload);
    },
  },
});

export const environmentStateActions = slice.actions;
export default slice.reducer;
